import BaseHttpService from './BaseHttpService';
import { IBaseHttpService } from '../types/Http';

import BlainBaseService from './BlainBaseService';
import EventBusService from './EventBusService';
import LoggerService from './LoggerService';
import { CustomerListsAddToListResponse, CustomerListsGetResponse } from '../types/Registry';
import { IEventBusService } from '../types/EventBus';
import { ILoggerService } from '../types/Logger';

export default class CustomerListService extends BlainBaseService {

	constructor(
		httpSvc: IBaseHttpService = new BaseHttpService(),
		logger: ILoggerService = new LoggerService(),
		eventBusService: IEventBusService = new EventBusService()
	) {
		super(eventBusService, logger, httpSvc);
	}

	async getCustomerLists(): Promise<CustomerListsGetResponse> {
		return this._httpSvc.get<CustomerListsGetResponse>('/gift-registry/get-list');
	}

	async addItemToList(blainNumber: string, listID: number | string, qty: number = 1): Promise<CustomerListsAddToListResponse> {
		return this._httpSvc.post<CustomerListsAddToListResponse>('/gift-registry/add', {
			blainNumber,
			qty,
			listID
		});
	}

}